<div
  *ngIf="!showEditNames"
  class="box-border flex items-center justify-between flex-none px-6 py-4 bg-neutrals-0 border-neutrals-300 round-top"
>
  <div class="w-full grid items-center grid-flow-col gap-3">
    <div class="grid grid-flow-col gap-[10px] justify-start items-center">
      <div
        class="flex flex-col justify-center items-center bg-[#fff6d9] box-border w-9 h-9 rounded-[36px]"
      >
        <ui-headline
          type="h14"
          mobile-type="h14"
          font-weight="bold"
          text-color="neutrals-900"
        >
          {{ getBadgeText() }}
        </ui-headline>
      </div>
      <div class="flex flex-col justify-start w-[130px]" #editableFieldsElement>
        <ui-headline
          type="h12"
          mobile-type="h12"
          font-weight="semibold"
          text-color="neutrals-900"
        >
          {{ getPrincipalText() }}
        </ui-headline>
        <ui-paragraph type="p10" mobile-type="p10" text-color="neutrals-600">
          {{ roleName }}
        </ui-paragraph>
      </div>
      <button
        #documentFieldElement
        type="button"
        class="flex h-[60%] cursor-pointer"
        (click)="onEditNames()"
        matTooltip="Editar"
        [disabled]="!isActivated"
      >
        <ui-icon name="edit" [fill]="getIconColor()" size="16" mSize="16" />
      </button>
    </div>
    <div class="grid grid-flow-col items-center gap-[8px]">
      <button
        class="block w-full h-5 overflow-hidden hover:scale-110"
        (click)="onClosingProbability()"
        [matTooltip]="
          hasHighClosingProbability ? 'Alta Probabilidad' : 'Baja Probabilidad'
        "
      >
        <ui-icon
          [attr.name]="hasHighClosingProbability ? 'ray' : 'ray-unfilled'"
          m-size="20"
          size="20"
          [attr.fill]="
            hasHighClosingProbability ? 'neutrals-900' : 'neutrals-500'
          "
        />
      </button>
      <button
        class="flex items-center justify-center"
        (click)="onFrame()"
        [matTooltip]="
          isRecurring ? 'Cliente recurrente' : 'Cliente no recurrente'
        "
      >
        <ui-icon
          *ngIf="isRecurring"
          name="star-round-filled"
          m-size="20"
          size="20"
          fill="neutrals-900"
        />
        <ui-icon
          *ngIf="!isRecurring"
          name="star-round"
          m-size="16"
          size="16"
          fill="neutrals-500"
        />
      </button>
      <button
        class="block w-full h-5 overflow-hidden hover:scale-110"
        (click)="onPin()"
        [matTooltip]="isPinned ? 'Desanclar' : 'Anclar'"
      >
        <ui-icon
          [attr.name]="isPinned ? 'pin-filled' : 'pin'"
          m-size="20"
          size="20"
          [attr.fill]="isPinned ? 'neutrals-900' : 'neutrals-500'"
        />
      </button>
    </div>
    <form
      [formGroup]="formSelect"
      class="h-[40px] w-full flex justify-center items-center"
    >
      <mat-form-field class="custom-select w-full">
        <mat-select
          formControlName="selectedColumn"
          (selectionChange)="onSelectedOption($event.value)"
        >
          <mat-option *ngFor="let option of options" [value]="option.id">
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <div class="w-full flex justify-end" *ngIf="showBtnClose">
      <button type="button" class="cursor-pointer" (click)="onShowIconDetail()">
        <ui-icon
          [attr.name]="iconShowDetail"
          fill="neutrals-900"
          m-size="20"
          size="20"
        />
      </button>
    </div>
  </div>
</div>

<form
  *ngIf="showEditNames"
  [formGroup]="form"
  class="box-border flex items-center gap-2 px-6 py-4 document-form bg-neutrals-0 border-neutrals-400"
  (submit)="onSendFullname()"
>
  <div
    class="unicon-form-input box-border flex px-3 py-2 items-center rounded-[8px] border-neutrals-100"
    [ngClass]="{
      error: form.get('leadNames')?.invalid && form.get('leadNames')?.touched,
    }"
    #fullnameBox
  >
    <input
      type="text"
      formControlName="leadNames"
      placeholder="Nombres"
      (focus)="fullnameBox.classList.add('focussed')"
      (blur)="fullnameBox.classList.remove('focussed')"
      class="bg-[#F7F9FC]"
    />
  </div>

  <div
    class="unicon-form-input box-border flex px-3 py-2 items-center rounded-[8px] border-neutrals-100"
    [ngClass]="{
      error:
        form.get('leadFirstSurname')?.invalid &&
        form.get('leadFirstSurname')?.touched,
    }"
    #paternalSurnameBox
  >
    <input
      type="text"
      formControlName="leadFirstSurname"
      placeholder="Apellido Paterno"
      (focus)="paternalSurnameBox.classList.add('focussed')"
      (blur)="paternalSurnameBox.classList.remove('focussed')"
      class="bg-[#F7F9FC]"
    />
  </div>

  <div
    class="unicon-form-input box-border flex px-3 py-2 items-center rounded-[8px] border-neutrals-100"
    [ngClass]="{
      error:
        form.get('leadSecondSurname')?.invalid &&
        form.get('leadSecondSurname')?.touched,
    }"
    #maternalSurnameBox
  >
    <input
      type="text"
      formControlName="leadSecondSurname"
      placeholder="Apellido Materno"
      (focus)="maternalSurnameBox.classList.add('focussed')"
      (blur)="maternalSurnameBox.classList.remove('focussed')"
      class="bg-[#F7F9FC]"
    />
  </div>

  <button
    class="bg-unicon-yellow-100 px-3 flex items-center justify-center w-7 h-7 rounded-[6px]"
  >
    <ui-icon name="check" m-size="18" size="18" fill="neutrals-900" />
  </button>
</form>
